import React from 'react';
import '../css/Navbar.css';
import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { useState } from 'react';
import { Link } from "react-scroll";
import myLogo from '../img/logo.png'

function Navbar() {
    const [showMenu, setShowMenu] = useState(false);

    return (
        <div className="navbar">
            <div className="navbar__navigation" >
                <ul style={{ transform: showMenu ? 'translateX(0px)' : '' }}>

                    <div className="logo">
                        <img src={myLogo} alt=""/>
                        <CloseOutlinedIcon style={{ fontSize: '55px', cursor: 'pointer', marginRight: '30px' }} onClick={() => setShowMenu(!showMenu)} />
                    </div>

                    <Link
                        onClick={() => setShowMenu(!showMenu)}
                        activeClass="active"
                        to="banner"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    ><li>INTRO</li></Link>
                    <Link
                        onClick={() => setShowMenu(!showMenu)}
                        activeClass="active"
                        to="about"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    ><li>ABOUT</li></Link>
                    <Link
                        onClick={() => setShowMenu(!showMenu)}
                        activeClass="active"
                        to="whatido"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    ><li>WHAT I DO</li></Link>
                    <Link
                        onClick={() => setShowMenu(!showMenu)}
                        activeClass="active"
                        to="skills"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    ><li>SKILLS</li></Link>
                    <Link
                        onClick={() => setShowMenu(!showMenu)}
                        activeClass="active"
                        to="portfolio"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    ><li>PORTFOLIO</li></Link>
                    <Link
                        onClick={() => setShowMenu(!showMenu)}
                        activeClass="active"
                        to="contact"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    ><li>CONTACT</li></Link>



                </ul>
                <div className="menuIcon">
                    {showMenu ? 
					<MenuOutlinedIcon onClick={() => setShowMenu(!showMenu)} c
					lassName="menuIcon" style={{ display: 'none' }} /> 
					: <MenuOutlinedIcon onClick={() => setShowMenu(!showMenu)} 
					className="menuIcon" style={{ color: 'white', fontSize: '60px', 
					marginLeft: '520px', top: '10', position: 'fixed' }} />}

                </div>
            </div>
        </div>
    )
}

export default Navbar;
